import React from 'react';
import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  { name: 'LinkedIn', href: 'https://linkedin.com/company/maxmarkagency' },
  { name: 'Instagram', href: 'https://instagram.com/maxmarkagency' },
  { name: 'Twitter', href: 'https://x.com/maxmarkagency' }
];

export default function Footer() {
  return (
    <footer className="bg-black pt-40 pb-20 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 lg:gap-24 mb-28">
          
          <div className="md:col-span-4">
            <h3 className="text-3xl font-serif font-bold mb-6 text-white tracking-tight">
              MAXMARK<span className="text-[#2F6BFF]">.</span>
            </h3>
            <p className="text-base text-zinc-400 leading-relaxed font-light mb-10">
              Creative Intelligence. Built in Africa. Ready for the world. We help ambitious brands see the market, decide intelligently, and execute creatively.
            </p>
            <div className="space-y-3 pt-6 border-t border-zinc-900">
              <h4 className="text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500">Headquarters</h4>
              <p className="text-xs text-zinc-400">77 Ogudu Ojota, Ogudu, Lagos, Nigeria</p>
              <p className="text-xs text-zinc-400">info@maxmarkagency.com</p>
              <p className="text-xs text-zinc-400">+234 816 058 2474</p>
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-6">
            <h4 className="text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500 mb-8">Capabilities</h4>
            <ul className="space-y-4">
              <li><Link to="/intelligence" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Intelligence</Link></li>
              <li><Link to="/creative-services" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Creative Services</Link></li>
              <li><Link to="/solutions" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Solutions</Link></li>
              <li><Link to="/plans" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Plans</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500 mb-8">Company</h4>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">About</Link></li>
              <li><Link to="/work" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Work</Link></li>
              <li><Link to="/insights" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Insights</Link></li>
              <li><Link to="/contact" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[10px] font-bold tracking-[0.3em] uppercase text-zinc-500 mb-8">Legal</h4>
            <ul className="space-y-4">
              <li><Link to="/privacy" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookies" className="text-xs font-bold uppercase tracking-widest text-zinc-400 hover:text-blue-500 transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>

        </div>

        <div className="border-t border-zinc-900 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-zinc-600 text-[10px] font-bold tracking-[0.3em] uppercase">
            © {new Date().getFullYear()} Maxmark Agency. All Rights Reserved.
          </div>
          <div className="flex gap-8">
            {SOCIAL_LINKS.map(social => (
              <a 
                key={social.name} 
                href={social.href} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 hover:text-white transition-colors"
              >
                {social.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}